export default __webpack_public_path__ + "static/avatar-do-2-dark-787a397f759f6bf07082d1831e9adb2d.png";